import React, { useState } from 'react';
import {
  CCard,
  CCardBody,
  CCardGroup,
  CCol,
  CContainer,
  CRow,
} from '@coreui/react';
import LoginForm from '../containers/LoginForm';
import ForgotPasswordForm from '../containers/ForgotPasswordForm';

const Login = () => {
  const [forgotPassword, setForgotPassword] = useState(false);
  return (
    <div className="c-app c-default-layout flex-row align-items-center">
      <CContainer>
        <CRow className="justify-content-center">
          <CCol md="8" lg="6">
            <CCardGroup>
              <CCard className="p-4">
                <CCardBody>
                  {!forgotPassword && (
                    <LoginForm
                      forgotPassword={forgotPassword}
                      setForgotPassword={setForgotPassword}
                    />
                  )}
                  {forgotPassword && (
                    <ForgotPasswordForm
                      forgotPassword={forgotPassword}
                      setForgotPassword={setForgotPassword}
                    />
                  )}
                </CCardBody>
              </CCard>
            </CCardGroup>
          </CCol>
        </CRow>
      </CContainer>
    </div>
  );
};

export default Login;
